import { X } from "lucide-react";
import { useData } from "../lib/DataContext";
import { fmt } from "../lib/api";
import { TierBadge } from "./shared";

// Read-only BOM summary overlaid on a flowchart canvas.
export default function BomDetailCard({ productId, onClose }) {
  const { boms, itemsById } = useData();
  const bom = boms.find((b) => b.product_id === productId);
  const p = itemsById[productId];
  if (!bom || !p) return null;
  const mins = bom.resource_type === "machine" ? (bom.setup_labor_minutes || 0) + (bom.machine_run_minutes || 0) : bom.production_time_minutes || 0;
  return (
    <div data-testid="bom-detail-card" onClick={(e) => e.stopPropagation()}
      className="absolute top-3 right-3 z-20 w-[min(440px,94%)] max-h-[calc(100%-1.5rem)] overflow-y-auto rounded-md border-2 border-[#F59E0B] bg-[#0B111D]/95 backdrop-blur-md shadow-[0_12px_40px_rgba(0,0,0,0.6)] p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="font-mono text-[10px] tracking-[0.2em] text-[#F59E0B]">BOM DETAILS · READ ONLY</div>
          <div className="font-display text-lg font-extrabold text-white truncate" data-testid="bom-detail-name">{bom.name}</div>
        </div>
        <button data-testid="bom-detail-close" onClick={onClose} data-tip="Close" className="h-8 w-8 shrink-0 grid place-items-center rounded border border-[#334155] text-[#9CA3AF] hover:text-white"><X className="w-4 h-4" /></button>
      </div>
      <div className="mt-3 p-3 rounded-md bg-[#090D16] border border-[#1E293B]" data-testid="bom-detail-parent">
        <div className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280] mb-1">PARENT ITEM</div>
        <div className="flex items-center gap-2"><TierBadge tier={p.tier} /><span className="font-semibold text-white truncate">{p.name}</span></div>
        <div className="font-mono text-[11px] text-[#6B7280] mt-0.5">{p.sku} · {fmt(p.stock)} / {fmt(p.par_level)} {p.unit} par{mins ? ` · ${fmt(mins)} min/unit` : ""}</div>
      </div>
      <div className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280] mt-3 mb-1">SUB-COMPONENTS · PER 1 {p.unit?.toUpperCase()}</div>
      <div className="divide-y divide-[#1E293B] border border-[#1E293B] rounded-md">
        {bom.components.map((c) => {
          const it = itemsById[c.item_id];
          return (
            <div key={c.item_id} data-testid={`bom-detail-line-${it?.sku || c.item_id}`} className="flex items-center gap-2 px-3 py-2 text-sm">
              {it && <TierBadge tier={it.tier} />}
              <div className="min-w-0 flex-1"><div className="truncate text-white">{it?.name || "Deleted item"}</div><div className="font-mono text-[10px] text-[#6B7280]">{it?.sku} · {fmt(it?.stock)} in stock</div></div>
              <div className="font-mono font-bold text-[#F59E0B] whitespace-nowrap" data-testid={`bom-detail-qty-${it?.sku || c.item_id}`}>× {c.qty >= 1 ? fmt(c.qty) : Number(c.qty.toPrecision(3))} {it?.unit}</div>
            </div>
          );
        })}
        {!bom.components.length && <div className="px-3 py-3 text-sm text-[#6B7280]">No components</div>}
      </div>
    </div>
  );
}
